import { createSlice } from '@reduxjs/toolkit';

export const commonSlice = createSlice({
    name: 'commonReducer',
    initialState: {
        value: true,
        otp_id: "",
        verify_status: false,
        showOtpSection: false,
        showTimer: false,
        otp_loader: false,
        hide_send_otp: false,
        profile_validated: null,
        details_validated: null,
        submitLoader: false,
        continue_timer: false,
        timer_active: false,
        ip_address : ""
    },
    reducers: {
        updateRedux: (state, data) => {
            state[data.payload.key] = data.payload.value
        },
    },
})

export const { updateRedux } = commonSlice.actions;

export const value = (state) => state.commonReducer.value;
export const banner_lists = (state) => state.commonReducer.banner_lists;
export const visionMision_lists = (state) => state.commonReducer.visionMision_lists;
export const getHome_lists = (state) => state.commonReducer.getHome_lists;
export const rolesAssign_lists = (state) => state.commonReducer.rolesAssign_lists;
export const About_details = (state) => state.commonReducer.About_details;
export const AboutValues_details = (state) => state.commonReducer.AboutValues_details;
export const contactInfo_details = (state) => state.commonReducer.contactInfo_details;
export const jurisdictionAuthorities_details = (state) => state.commonReducer.jurisdictionAuthorities_details;
export const otp_id = (state) => state.commonReducer.otp_id;
export const expireTime = (state) => state.commonReducer.expireTime;
export const incident_details = (state) => state.commonReducer.incident_details;
export const verify_status = (state) => state.commonReducer.verify_status;
export const incident_type_details = (state) => state.commonReducer.incident_type_details;
export const showOtpSection = (state) => state.commonReducer.showOtpSection;
export const showTimer = (state) => state.commonReducer.showTimer;
export const otp_loader = (state) => state.commonReducer.otp_loader;
export const hide_send_otp = (state) => state.commonReducer.hide_send_otp;
export const profile_validated = (state) => state.commonReducer.profile_validated;
export const details_validated = (state) => state.commonReducer.details_validated;
export const submitLoader = (state) => state.commonReducer.submitLoader;
export const continue_timer = (state) => state.commonReducer.continue_timer;
export const timer_active = (state) => state.commonReducer.timer_active;
export const update_report_no = (state) => state.commonReducer.update_report_no;
export const incidentContent = (state) => state.commonReducer.incidentContent;
export const created_incident_number = (state) => state.commonReducer.created_incident_number;
export const banner_path = (state) => state.commonReducer.banner_path;
export const home_path = (state) => state.commonReducer.home_path;
export const rolesAssign_path = (state) => state.commonReducer.rolesAssign_path;
export const about_path = (state) => state.commonReducer.about_path;
export const contactInfo_path = (state) => state.commonReducer.contactInfo_path;
export const jurisdictionAuthorities_path = (state) => state.commonReducer.jurisdictionAuthorities_path;
export const local_storage_language = (state) => state.commonReducer.local_storage_language;
export const ip_address = (state) => state.commonReducer.ip_address;

export default commonSlice.reducer;